import React from "react";
import { useParams } from "react-router-dom";
import { Grid, GridItem, Flex } from "@chakra-ui/react";

import IconClassroom from "@/assets/IconClassroom.svg?url";
import IconCourses from "@/assets/IconCourses.svg?url";

import { Tab, TabProps } from "./Tab";
import { useLicenseStore } from "@/stores/v2/licenseStore";
import { useCoursesStore } from "@/stores/v2/coursesStore";
import { StudentClaimBanner } from "@/js/components/StudentClaims/StudentClaimsBanner";
import { useTranslation } from "react-i18next";

export const TabBar: React.FC<{
	/** Opens the shared Student management modal (provided by RegularClassroom). */
	onOpenStudentClaimsModal?: () => void;
	isActive: boolean;
}> = ({ onOpenStudentClaimsModal, isActive }) => {
	const { t } = useTranslation();
	const params = useParams<string>();
	const licenseStore = useLicenseStore();
	const coursesStore = useCoursesStore();
	const classroomTab: TabProps = {
		title: t("classroomDetails.classroomTab"),
		icon: IconClassroom,
		route: `/classroom/${params.classId as string}`,
		strictRouteCheck: true,
		isNew: !licenseStore.classroom,
	};

	const coursesTab: TabProps = {
		title: t("classroomDetails.coursesTab"),
		icon: IconCourses,
		route: `/classroom/${params.classId as string}/courses`,
	};

	const hallwayPassTab: TabProps = {
		title: t("classroomDetails.hallwayPassTab"),
		faIcon: "fa-id-card-clip",
		route: `/classroom/${params.classId as string}/hallway-pass`,
	};

	// const pulseTab: TabProps = {
	// 	title: "Pulse",
	// 	icon: IconPulse,
	// 	route: `/classroom/${params.classId}/pulse`,
	// 	isComingSoon: true,
	// };

	const tabs: TabProps[] = [];

	if (coursesStore.showCoursesTab && !licenseStore.classroom) {
		tabs.push(coursesTab);
	}

	tabs.push(classroomTab);

	if (licenseStore.hallPass) {
		tabs.push(hallwayPassTab);
	}

	if (coursesStore.showCoursesTab && licenseStore.classroom) {
		tabs.push(coursesTab);
	}

	return (
		<Grid
			position="relative"
			width="100%"
			px={{ base: 3, md: 5 }}
			pt={{ base: 2, md: 2 }}
			pb={0}
			zIndex={9}
			bg="#e8f4f3"
			/* Tabs use a bottom border as the active indicator; keep them end-aligned so a taller banner column does not vertically center the tabs and “raise” that line. */
			alignItems="end"
			templateColumns={{ base: "1fr", md: "minmax(0, 1fr) auto minmax(0, 1fr)" }}
			gap={{ base: 2, md: 2 }}
		>
			<GridItem justifySelf="start" minW={0}>
				<Flex alignItems="center" flexWrap="nowrap">
					{tabs.map((tabDetails, index) => (
						<Tab
							key={index}
							title={tabDetails.title}
							icon={tabDetails.icon}
							faIcon={tabDetails.faIcon}
							route={tabDetails.route}
							strictRouteCheck={tabDetails.strictRouteCheck}
							isNew={tabDetails.isNew}
							isComingSoon={tabDetails.isComingSoon}
						/>
					))}
				</Flex>
			</GridItem>
			<GridItem justifySelf={{ base: "center", md: "center" }} minW={0} maxW={{ base: "100%", md: "min(560px, 90vw)" }}>
				{isActive && <StudentClaimBanner onViewDetails={onOpenStudentClaimsModal} />}
			</GridItem>
			<GridItem display={isActive ? "block" : "none"} minW={0} aria-hidden />
		</Grid>
	);
};
